import BaseEvent from './base-event';

function eventCallback(destinationUrl) {
    console.log('eventCallback', destinationUrl);
    setTimeout(() => {
        window.location = destinationUrl;
    }, 500);
}

export default class ProductEvents extends BaseEvent {
    constructor(name = null, id = null, category = null) {
        super();

        this.name = name;
        this.id = id;
        this.category = category;

        this.promotionDataLayer = {
            event: null,
            ecommerce: null,
        };
        this.product = {
            name: null,
            id: this.id,
            creative: null,
            position: 1,
        };
    }

    promoImpressionEvent(currentTarget) {
        const event = 'promoImpression';
        const measurement = 'promoView';
        const dataLayer = this.createDataLayer(event, measurement, currentTarget, !currentTarget.length);
        window.dataLayer.push({ ecommerce: null });
        return window.dataLayer.push(dataLayer);
    }

    promoClickEvent(currentTarget) {
        const event = 'promotionClick';
        const measurement = 'promoClick';
        const dataLayer = this.createDataLayer(event, measurement, currentTarget);
        eventCallback.call(this, currentTarget.href);

        window.dataLayer.push({ ecommerce: null });
        return window.dataLayer.push(dataLayer);
    }

    productDetailEvent() {
        const event = 'productDetail';
        const measurement = 'detail';

        const dataLayer = { ...this.promotionDataLayer };
        dataLayer.event = event;
        dataLayer.ecommerce = {};
        dataLayer.ecommerce[measurement] = {
            products: [{
                name: this.toNormalizedString(this.name),
                id: this.id,
                brand: 'mancity',
                category: this.category,
            }],
        };

        window.dataLayer.push({ ecommerce: null });
        return window.dataLayer.push(dataLayer);
    }

    createDataLayer(event, measurement, currentTarget, oneProduct = true) {
        const dataLayer = { ...this.promotionDataLayer };
        dataLayer.event = event;
        dataLayer.ecommerce = {};
        dataLayer.ecommerce[measurement] = {
            promotions: [],
        };

        if (oneProduct) {
            dataLayer.ecommerce[measurement].promotions = [{ ...this.product }];
            dataLayer.ecommerce[measurement].promotions[0].name = this.toNormalizedString(this.name);
            dataLayer.ecommerce[measurement].promotions[0].creative = this.toNormalizedString(currentTarget.innerText || currentTarget.innerHTML);
        } else {
            const promotions = [];
            currentTarget.forEach((element, i) => {
                const product = { ...this.product };
                product.position = i + 1;
                product.name = this.toNormalizedString(element.title);
                product.id = this.toNormalizedString(element.title);
                product.price = element.dataset.price;
                product.category = this.category;
                product.brand = 'mancity';

                promotions.push(product);
            });
            dataLayer.ecommerce[measurement].promotions = promotions;
        }

        return dataLayer;
    }
}
